import React from 'react'
import styled, { css } from 'styled-components'

const width = '20'
const height = '19'
const viewBox = '0 0 20 19'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#BDC3CD"
      d="M14.362 0c-1.724 0-3.378.802-4.457 2.07C8.825.802 7.17 0 5.448 0 2.397 0 0 2.397 0 5.448c0 3.743 3.368 6.794 8.468 11.43l1.437 1.297 1.436-1.307c5.1-4.626 8.468-7.677 8.468-11.42C19.81 2.397 17.412 0 14.362 0zm-4.358 15.402l-.1.099-.098-.1C5.09 11.134 1.98 8.31 1.98 5.449c0-1.981 1.486-3.467 3.467-3.467 1.525 0 3.01.98 3.536 2.337h1.852c.515-1.357 2-2.337 3.526-2.337 1.98 0 3.466 1.486 3.466 3.467 0 2.862-3.11 5.685-7.824 9.954z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconAccountHeart'
})
